export interface IFacturaAccionesInput {
  estado?: string;
  estadoPago?: string;
  bonoId?: string | null;
  metodoPago?: { nombre?: string; codigo?: number } | null;
  facturaRectificadaId?: string | null;
  tipoRectificacion?: string | null;
  tieneOpcionAnular?: boolean;
}

export interface IFacturaAcciones {
  mostrarBotonesAccion: boolean;
  mostrarPagar: boolean;
  variantPagar: "outlined" | "contained";
  mostrarEmitir: boolean;
  variantEmitir: "outlined" | "contained";
  mostrarMenuAcciones: boolean;
  mostrarCorregirCobro: boolean;
  mostrarRectificar: boolean;
}

// Centraliza las condiciones de visibilidad repetidas en los 6 diálogos de detalle de
// factura (cita, parcial, clase, bono, manual, complementaria) — pagarla/emitirla antes
// o después en cualquier orden (Bloque 1), corregir un cobro ya registrado salvo que se
// pagara con bono, y rectificar solo una vez emitida.
export const getFacturaAcciones = ({
  estado,
  estadoPago,
  bonoId,
  metodoPago,
  facturaRectificadaId,
  tipoRectificacion,
  tieneOpcionAnular,
}: IFacturaAccionesInput): IFacturaAcciones => {
  const esBorrador = estado === "Borrador";
  const esAnulada = estado === "Anulada";
  const esEmitida = estado === "Emitida";
  const estaPagada = estadoPago === "Pagada";
  const estaPendiente = estadoPago === "Pendiente";
  // Mismo criterio que esMetodoPagoBono (backend): nombre "Bono" o código 4.
  const pagadaConBono = !!bonoId && (metodoPago?.nombre === "Bono" || metodoPago?.codigo === 4);
  const noRectificada = !facturaRectificadaId;
  // La rectificativa por anulación la genera el sistema: no se cobra, ni se rectifica, ni se anula.
  const esAnulacion = tipoRectificacion === "anulacion";

  const mostrarCorregirCobro = estaPagada && !pagadaConBono && !esAnulacion;
  const mostrarRectificar = esEmitida && !esAnulacion;

  return {
    mostrarBotonesAccion: noRectificada && !esAnulacion && (esBorrador || (!esAnulada && estaPendiente)),
    mostrarPagar: estaPendiente && !esAnulacion,
    variantPagar: esBorrador ? "outlined" : "contained",
    mostrarEmitir: esBorrador,
    variantEmitir: estaPagada ? "contained" : "outlined",
    mostrarMenuAcciones: !esAnulada && noRectificada && (mostrarCorregirCobro || mostrarRectificar || (!!tieneOpcionAnular && !esAnulacion)),
    mostrarCorregirCobro,
    mostrarRectificar,
  };
};
